'use client';
import { Suspense } from 'react';
import { RegisterLanding } from '@paeffgen/react/crm-documents/feature-registration';
export default function LoginRoute() {
  return (
    <Suspense fallback={null}>
      <RegisterLanding />
    </Suspense>
  );
}
